module.exports = __webpack_public_path__ + "img/document-reject-2.bdc431fd.svg";